import createVueApp from '@/common/create_app'
import sidebar from '@/config/sidebars/geobooster'

Styxie.Initializers.MobileBusinesses = {
  index: async(props) => {
    const { default: BusinessesIndex } = await import('@/vue_widgets/geobooster/businesses/index.vue')
    createVueApp(BusinessesIndex, { props, sidebar })
  },
  new: async(props) => {
    const { default: BusinessesNew } = await import('@/vue_widgets/geobooster/businesses/new.vue')
    createVueApp(BusinessesNew, { props, sidebar })
  },
  show: async(props) => {
    const { default: BusinessShow } = await import('@/vue_widgets/geobooster/businesses/show/index.vue')
    createVueApp(BusinessShow, { props, sidebar })
  },
  dashboard: async(props) => {
    const { default: DashboardIndex } = await import('@/vue_widgets/geobooster/dashboard/index.vue')
    createVueApp(DashboardIndex, { props, sidebar })
  }
}
